// extracted by mini-css-extract-plugin
export default {"Information":"Information_Information__jP3WG","textContainer":"Information_textContainer__IvV+J","scrollTop":"Information_scrollTop__bnuPa","hidden":"Information_hidden__6uWhF"};